import { MultiTableSearchBox } from '@powerportalspro/react-fluent';

// A search box as a page's header would have it: the demo's customers suggested as you type, and
// every result on this page's search below.

export function MultiTableSearchBoxSample() {
  return <MultiTableSearchBox searchPageUrl="multi-table-search" style={{ width: 'min(480px, 100%)' }} />;
}
